import { UsaState } from '@/types/Address';
import type { FlightSchoolAdmin } from '@/types/FlightSchoolAdmin';

export function getMockFlightSchoolAdmins(): FlightSchoolAdmin[] {
    return [
        {
            name: 'John Doe',
            id: 8238343,
            isOwner: true,
            email: 'johndoe@example.com',
            phoneNumbers: { day: '786-232-3344' },
            address: {
                line1: '567 Pine St',
                line2: null,
                city: 'Miami',
                postcode: '33132',
                state: UsaState.FL,
                country: 'US',
            },
            emailSubscriber: true,
        },
        {
            name: 'Jane Smith',
            id: 3435345,
            isOwner: false,
            email: 'janesmith@example.com',
            phoneNumbers: { day: '305-556-7788', evening: '305-558-9900' },
            address: {
                line1: '234 Oak Ave',
                line2: null,
                city: 'Orlando',
                postcode: '32803',
                state: UsaState.FL,
                country: 'US',
            },
            emailSubscriber: true,
        },
        {
            name: 'Robert Johnson',
            id: 1842304,
            isOwner: false,
            email: 'robertj@example.com',
            phoneNumbers: { day: '212-334-7788' },
            address: {
                line1: '123 Pearl St',
                line2: null,
                city: 'New York',
                postcode: '10005',
                state: UsaState.NY,
                country: 'US',
            },
            emailSubscriber: false,
        },
        {
            name: 'Maria Garcia',
            id: 988574,
            isOwner: true,
            email: 'mariag@example.com',
            phoneNumbers: { day: '213-334-7788' },
            address: {
                line1: '567 Broadway St',
                line2: null,
                city: 'Los Angeles',
                postcode: '90210',
                state: UsaState.CA,
                country: 'US',
            },
            emailSubscriber: true,
        },
        {
            name: 'Steve Brown',
            id: 888473,
            isOwner: false,
            email: 'steveb@example.com',
            phoneNumbers: { day: '512-665-7788' },
            address: {
                line1: '2900 S Congress Ave',
                line2: null,
                city: 'Austin',
                postcode: '78704',
                state: UsaState.TX,
                country: 'US',
            },
            emailSubscriber: false,
        },
        {
            name: 'Emily Davis',
            id: 444536,
            isOwner: false,
            email: 'emilyd@example.com',
            phoneNumbers: { day: '303-445-3345' },
            address: {
                line1: '456 Maple St',
                line2: null,
                city: 'Denver',
                postcode: '80203',
                state: UsaState.CO,
                country: 'US',
            },
            emailSubscriber: false,
        },
        {
            name: 'James Wilson',
            id: 444637,
            isOwner: false,
            email: 'jamesw@example.com',
            phoneNumbers: { day: '225-334-6756' },
            address: {
                line1: '789 Oak Dr',
                line2: null,
                city: 'Baton Rouge',
                postcode: '70808',
                state: UsaState.LA,
                country: 'US',
            },
            emailSubscriber: false,
        },
        {
            name: 'Patricia Miller',
            id: 857394,
            isOwner: false,
            email: 'patriciam@example.com',
            phoneNumbers: { day: '619-556-7878', evening: '619-334-5566' },
            address: {
                line1: '678 Palm Ave',
                line2: null,
                city: 'San Diego',
                postcode: '92101',
                state: UsaState.CA,
                country: 'US',
            },
            emailSubscriber: true,
        },
        {
            name: 'Michael Moore',
            id: 998743,
            isOwner: false,
            email: 'michaelm@example.com',
            phoneNumbers: { day: '312-445-7788' },
            address: {
                line1: '890 Lakeshore Dr',
                line2: null,
                city: 'Chicago',
                postcode: '60007',
                state: UsaState.IL,
                country: 'US',
            },
            emailSubscriber: false,
        },
        {
            name: 'Sarah Taylor',
            id: 335256,
            isOwner: false,
            email: 'saraht@example.com',
            phoneNumbers: { day: '206-334-7788' },
            address: {
                line1: '345 Northgate',
                line2: null,
                city: 'Seattle',
                postcode: '98101',
                state: UsaState.WA,
                country: 'US',
            },
            emailSubscriber: false,
        },
    ];
}
